// extracted by mini-css-extract-plugin
export default {"settings":"styles_settings__XPXqj","theme_button":"styles_theme_button__2rjWa","active_theme_button":"styles_active_theme_button__fZn3C"};